/**************************************************
 * Nombre:       Seccion_Locales
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Locales_Portada from "./Componentes/Locales_Portada";
import Home_Lineas from "./Componentes/Home_Lineas";
import Locales_VerCatalogo from "./Componentes/Locales_VerCatalogo";
import Locales_ListaLocales from "./Componentes/SucComponentes/Locales_ListaLocales";
import Locales_PorMayor from "./Componentes/Locales_PorMayor";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Locales = () => {
    const {sCell} = useResponsive()

    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Locales_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Lineas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Locales_VerCatalogo/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? -6 : 0}}>
                <Locales_ListaLocales/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 16}}>
                <Locales_PorMayor/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Testimonios/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Locales